import * as yup from 'yup';

const schema = yup.object({
     email: yup.string().required(),
     password: yup.string().required()
});

export default schema;